



//测试
// const domain = "https://woshimiapptest.mvoicer.com"
// //谁是卧底测试接口
// const domainSpy = "http://sheishiwoditest.mvoicer.com"
// //狼人杀
// const domainlrs = 'http://langrenshatest.mvoicer.com'
// const domaindraw = 'https://drawsomethingtest.mvoicer.com'
// //排行榜接口
// const smkdomain='https://woshimimalltest.mvoicer.com/woshimi_app'


//生产
const domain = "https://api.xiyacs.com/app"
const domainSpy = "https://api.xiyacs.com/undercover"
const domainlrs = 'https://api.xiyacs.com/werewolf'
const domaindraw = 'https://drawsomething.mvoicer.com'
const smkdomain='https://api.xiyacs.com/mall/woshimi_app'

// console.log(process.env)

const interfaces = {
  invite: domain + "/woshimi_app/user/invite",
  saleReceive: domain + "/woshimi_app/user/invite/prize",
  inviteRoom: domain + "/woshimi_app/drama/getGameInviteInfo",
  shareId: domain + "/woshimi_app/user/id",
  getDrameInfo:domain+"/woshimi_app/drama/getDramaInfoV2",
  getWebSquareBaseDetail:domain+"/woshimi_app/square/getWebSquareBaseDetail",
  //谁是卧底分享 （邀请）信息
  getDeceitInfo : domainSpy+"/sheishiwodi_app/game/getGameInviteInfo",
  //狼人杀
  getLrsInfo : domainlrs +'/langrensha_app/common/getGameInviteInfo',
  //你画我猜
  getDrawInfo : domaindraw +'/drawsomething_app/common/getGameInviteInfo',
  //排行榜(mall 接口)
  getGiftWeekRank: smkdomain +'/activity/getGiftWeekRank',
  //排行榜v2
  getGiftWeekRankV2: smkdomain +'/activity/getGiftTimeRank',
  //网页支付(公众号)
  tcGetGoods : smkdomain+'/web/recharge/goods',
  tcPay: smkdomain+'/web/front/pay',
  getTcuserInfo : domain+'/woshimi_app/user/id',
  //获取授权信息
  getWxMandateInfo : smkdomain+'/system/wechat/officialAccounts/authorization' ,
  //订单查询
  order:smkdomain+'/web/verify/pay',
  //抽奖
  lotteryHome : smkdomain+'/activity/getLotteryInfo',
  lottery: smkdomain+'/activity/getLotteryPrize',
  lotteryrecord:smkdomain+'/activity/getLotteryPrizeRecord',
  //video lottery
  videoLottery : smkdomain+'/activity/getLotteryWatchAdvertVideoPrize',
  fiction:domain+'/woshimi_app/fiction/h5/getFictionH5Details'
}
module.exports = interfaces





// WEBPACK FOOTER //
// ./src/utlis/network.js